import http from './_http'
import config from "@/config";
import { isWxH5 } from "@utils/business";

/**
 * 下单添加地址
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderAddressCheck = (params = {}) => {
    return http({
        url: '/order/address_check',
        method: 'post',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 退款进度
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderRefundProcess = (params = {}) => {
    return http({
        url: '/order/refund_process',
        method: 'get',
        params: { source: 2, ...params },
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 通过助力id 和 对应服务id 获取服务数据
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderWaiterCategory = (params = {}) => {
    return http({
        url: '/order/waiter_category',
        method: 'get',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 下单页获取价格
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderPriceCal = (params = {}) => {
    return http({
        url: '/order/price_cal',
        method: 'post',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 下单页创建订单支付
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderCreate = (params = {}) => {
    return http({
        url: '/order/create',
        method: 'post',
        params: { appId: config.appid, payType: 1, ...params },
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 普通用户订单列表
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderOrderPage = (params = {}) => {
    return http({
        url: '/order/order_page',
        method: 'get',
        params: { limit: 10, page: 1, type: 0, ...params },
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 普通用户订单详情
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderOrderDetail = (params = {}) => {
    return http({
        url: '/order/order_detail',
        method: 'get',
        params: params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 最近联系人
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderLastContact = (params = {}) => {
    return http({
        url: '/order/last_contact',
        method: 'get',
        params: { ...params },
    });
}

/**
 * 延迟服务生成订单
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderDelayOrder = (params = {}) => {
    return http({
        url: '/order/delay_order',
        method: 'post',
        params: { appId: config.appid, payType: 1, ...params },
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}


/**
 * 删除订单
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderDeleteOrder = (params = {}) => {
    return http({
        url: '/order/delete_order',
        method: 'post',
        params: params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 助理
 * 服务须知 弹窗
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderDeductRule = (params = {}) => {
    return http({
        url: '/order/deduct_rule',
        method: 'get',
        params: { ...params },
    });
}

/**
 * (内部mock) 支付成功
 * @param orderId
 * @returns {Promise | Promise<unknown>}
 */
export const orderPaySuccess = (orderId) => {
    return http({
        url: '/order/paySuccess',
        method: 'get',
        params: { orderId },
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 *
 * 订购须知
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderOrderInstructions = (params = {}) => {
    return http({
        url: '/order/order_instructions',
        method: 'get',
        params: { ...params },
    });
}

/**
 * 助理
 * 服务须知
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderServiceInstructions = (params = {}) => {
    return http({
        url: '/order/service_instructions',
        method: 'get',
        params: { ...params },
    });
}

/**
 * 取消、退款、赔付规则
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderOrderRule = (params = {}) => {
    return http({
        url: '/order/order_rule',
        method: 'get',
        params: { ...params },
    });
}

/**
 * 取消订单详情
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderOrderCancelDetail = (params = {}) => {
    return http({
        url: '/order/order_cancel_detail',
        method: 'get',
        params: params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 取消订单原因列表
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderCancelReason = (params = {}) => {
    return http({
        url: '/order/cancel_reason',
        method: 'get',
        params: params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 取消订单
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderOrderCancel = (params = {}) => {
    return http({
        url: '/order/order_cancel',
        method: 'post',
        params: { source: 2, ...params },
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 地址查询
 * @param addressId
 * @returns {Promise | Promise<unknown>}
 */
export const orderAddressInfo = (addressId) => {
    return http({
        url: '/order/address_info',
        method: 'get',
        params: { addressId },
    });
}

/**
 * 下单页创建订单
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderCreateOrder = (params = {}) => {
    return http({
        url: '/order/create_order',
        method: 'post',
        params: { appId: isWxH5() ? 'wxe6eec2e6ae38c3cd' : config.appid, payType: 1, ...params },
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 普通下单根据订单 id 获取支付信息
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderOrderPay = (params = {}) => {
    return http({
        url: '/order/order_pay',
        method: 'post',
        params: { appId: config.appid, payType: isWxH5() ? 3 : 1, ...params },
        meta: {
            login: true,
            toast: true,
            loading: true,
            loadingText: '支付中'
        },
    });
}

/**
 * 延长服务 根据订单 id 获取支付信息
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderDelayOrderPay = (params = {}) => {
    return http({
        url: '/order/delay_order_pay',
        method: 'post',
        params: { appId: config.appid, payType: isWxH5() ? 3 : 1, ...params },
        meta: {
            login: true,
            toast: true,
            loading: true,
            loadingText: '支付中'
        },
    });
}

/**
 * 延时订单付款成功检查
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderDelayOrderPaySuccessCheck = (params = {}) => {
    return http({
        url: '/order/delayOrderPaySuccessCheck',
        method: 'get',
        params: { ...params },
        repeat: 0,
    });
}

/**
 * 首单 付款成功检查
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderPaySuccessCheck = (params = {}) => {
    return http({
        url: '/order/paySuccessCheck',
        method: 'get',
        params: { ...params },
        repeat: 0,
    });
}

/**
 * 提交评价
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderEvaluateCommit = (params) => {
    return http({
        url: '/order/evaluate/commit',
        method: 'post',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        },
    });
}

/**
 * 根据评分获取评价列表
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderEvaluateWindow = (params) => {
    return http({
        url: '/order/evaluate/window',
        method: 'get',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        },
    });
}

/**
 * 获取见面码
 * @param orderId
 * @returns {Promise | Promise<unknown>}
 */
export const orderMeetCodeParam = (orderId) => {
    return http({
        url: '/order/meetcode/param',
        method: 'get',
        params: { orderId },
    });
}


/**
 *  扫码确认
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const orderMeetCodeScan = (params) => {
    return http({
        url: '/order/meetcode/scan',
        method: 'post',
        params,
        meta: {
            login: true,
            loading: true,
        }
    });
}
